import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#fff',
				secondary: '#C1272D',
				accent: '#636363',
				error: '#b71c1c',
				background: '#8fc9ba',
				admin_primary: '#ECEFF1',
				admin_secondary: '#607D8B',
				admin_accent: '#37474F',
				admin_info: '#5D4037',
				admin_red: '#C1272D',
				admin_card_bar: '#1A237E',
				admin_list: '#C5CAE9',

			},
		},
	},
});
